import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import SvgWrapper from './SvgWrapper';
import { ReactComponent as Blogs } from './svgs/blogs.svg?react';
import { ReactComponent as Facebook } from './svgs/facebook.svg?react';
import { ReactComponent as Forums } from './svgs/forums.svg?react';
import { ReactComponent as Instagram } from './svgs/instagram.svg?react';
import { ReactComponent as Linkedin } from './svgs/linkedin.svg?react';
import { ReactComponent as TikTok } from './svgs/tiktok.svg?react';
import { ReactComponent as Web } from './svgs/web.svg?react';
import { ReactComponent as Wordpress } from './svgs/wordpress.svg?react';
import { ReactComponent as X } from './svgs/x.svg?react';
import { ReactComponent as YouTube } from './svgs/youtube.svg?react';

const wrapIcon =
  (Component: any, defaultColor?: string) =>
  ({
    useDefaultColor = !!defaultColor,
    ariaLabel,
    ...props
  }: {
    ariaLabel?: string;
    size?: string;
    disabled?: boolean;
    useDefaultColor?: boolean;
  }) => (
    <SvgWrapper {...props} color={useDefaultColor && defaultColor ? defaultColor : undefined}>
      <Component role="img" aria-label={ariaLabel} viewBox="0 0 40 40" />
    </SvgWrapper>
  );

const SocialIcons = {
  Blogs: wrapIcon(Blogs, GREY_900),
  Facebook: wrapIcon(Facebook, '#1877F2'),
  Forums: wrapIcon(Forums, GREY_900),
  LinkedIn: wrapIcon(Linkedin, '#0077B5'),
  Wordpress: wrapIcon(Wordpress, '#3E3D3A'),
  YouTube: wrapIcon(YouTube, '#FF0000'),
  Instagram: wrapIcon(Instagram),
  Web: wrapIcon(Web, '#FC628F'),
  Twitter: wrapIcon(X, 'black'),
  'X (Twitter)': wrapIcon(X, 'black'),
  TikTok: wrapIcon(TikTok, 'black'),
};

export const SocialIconsDefault = () => <div />;
SocialIconsDefault.displayName = 'SocialIcons';

export default SocialIcons;
